<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="success">
    <div class="success" [ngClass]="title ? 'd-block' : 'd-flex align-items-center'">
      <ng-container *ngIf="title; else noTitleContent">
        <div class="d-flex align-items-center"><i nz-icon nzType="py-check-circle" nzTheme="fill"></i> {{ title }}</div>
        <div class="pt-2"><ng-container *ngTemplateOutlet="content"></ng-container></div>
      </ng-container>
      <ng-template #noTitleContent>
        <i nz-icon nzType="py-check-circle" nzTheme="fill"></i>
        <div><ng-container *ngTemplateOutlet="content"></ng-container></div>
      </ng-template>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="danger">
    <div class="danger" [ngClass]="title ? 'd-block' : 'd-flex align-items-center'">
      <ng-container *ngIf="title; else noTitleContent">
        <div class="d-flex align-items-center"><i nz-icon nzType="py-danger" nzTheme="fill"></i> {{ title }}</div>
        <div class="pt-2"><ng-container *ngTemplateOutlet="content"></ng-container></div>
      </ng-container>
      <ng-template #noTitleContent>
        <i nz-icon nzType="py-danger" nzTheme="fill"></i>
        <div><ng-container *ngTemplateOutlet="content"></ng-container></div>
      </ng-template>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="warning">
    <div class="warning" [ngClass]="title ? 'd-block' : 'd-flex align-items-center'">
      <ng-container *ngIf="title; else noTitleContent">
        <div class="d-flex align-items-center"><i nz-icon nzType="py-warning" nzTheme="fill"></i> {{ title }}</div>
        <div class="pt-2"><ng-container *ngTemplateOutlet="content"></ng-container></div>
      </ng-container>
      <ng-template #noTitleContent>
        <i nz-icon nzType="py-warning" nzTheme="fill"></i>
        <div><ng-container *ngTemplateOutlet="content"></ng-container></div>
      </ng-template>
    </div>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <div class="info" [ngClass]="title ? 'd-block' : 'd-flex align-items-center'">
      <ng-container *ngIf="title; else noTitleContent">
        <div class="d-flex align-items-center"><i nz-icon nzType="py-info-circle" nzTheme="fill"></i> {{ title }}</div>
        <div class="pt-2"><ng-container *ngTemplateOutlet="content"></ng-container></div>
      </ng-container>
      <ng-template #noTitleContent>
        <i nz-icon nzType="py-info-circle" nzTheme="fill"></i>
        <div><ng-container *ngTemplateOutlet="content"></ng-container></div>
      </ng-template>
    </div>
  </ng-container>
</ng-container>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
